var _style, _path, _g, _line, _polygon, _polygon2, _line2, _polygon3, _polygon4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodeTranslate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 100",
    style: {
      enableBackground: "new 0 0 32 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#626097;}\n\t.st2{fill:none;stroke:#FFFFFF;}\n\t.st3{fill:#626097;stroke:#626097;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    className: "st0",
    d: "M16,61.7c-6.4,0-11.5-5.1-11.5-11.5S9.6,38.7,16,38.7s11.5,5.1,11.5,11.5S22.4,61.7,16,61.7 L16,61.7z M16,39.8c-5.7,0-10.4,4.6-10.4,10.3S10.3,60.5,16,60.5s10.3-4.6,10.4-10.3S21.7,39.8,16,39.8L16,39.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_14"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 16,
    cy: 50.2,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 16,
    cy: 50.2,
    r: 4
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 16,
    y1: 30,
    x2: 16,
    y2: 11.3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "18.5,29.3 16,33.6 13.5,29.3 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "18.5,12 16,7.7 13.5,12 "
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 6.6,
    y1: 20.7,
    x2: 25.4,
    y2: 20.7
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "7.3,23.2 3,20.7 7.3,18.2 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "24.6,23.2 29,20.7 24.6,18.2 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeTranslate);
export default __webpack_public_path__ + "static/media/NodeTranslate.0b2043b5c25c8eb98a788df44abe1134.svg";
export { ForwardRef as ReactComponent };